export enum eventLabel {
  all = 'all',
  whatsapp = 'whatsapp',
  annual = 'annual',
  monthly = 'monthly',
}
